import { useMemo } from "react";
import { ListReceivesResponse } from "../../../common/api/Models/ListReceivesResponse";
import { useAxiosGet } from "../../../infrastructure/http";

export function useListReceives(
	status: string,
	locationId: number,
	displayType: string = "PurchaseOrders",
	failureReasons: string,
	manual?: boolean
) {
	return useAxiosGet<ListReceivesResponse>(
		useMemo(
			() => ({ url: "Receives", params: { status, displayType, locationId, failureReasons } }),
			[status, displayType, locationId, failureReasons]
		),
		manual ?? false
	);
}
